/**
 * Simple test for backend persistence
 * Just run testPersistence() in the browser console
 */
import * as api from '../api/api';

/**
 * Test if backend persistence is working
 */
window.testPersistence = async function(outcomeId = null) {
  console.log('🧪 Testing Backend Persistence...');
  
  try {
    // Get an outcome to test with
    if (!outcomeId) {
      const outcomes = await api.getOutcomes();
      if (outcomes.length === 0) {
        console.error('❌ No outcomes found');
        return false;
      }
      outcomeId = outcomes[0].id;
      console.log(`Using outcome: ${outcomes[0].name}`);
    }

    // Test the persistence endpoint
    console.log('Testing persistence endpoint...');
    const testData = [{
      role_id: 'test-role',
      roster_member_id: 'test-member',
      rate: 5000,
      company: 'CA',
      location: 'US',
      function: 'Developer',
      role: 'Test Role',
      lastRateUpdate: new Date().toISOString(),
      calculatedForYear: new Date().getFullYear()
    }];

    const result = await api.persistOutcomeRoleUpdates(outcomeId, testData);
    
    if (result && result.success !== false) {
      console.log('✅ Backend persistence is working!');
      console.log('Result:', result);
      return true;
    } else {
      console.warn('⚠️ Backend returned unexpected result:', result);
      return false;
    }
    
  } catch (error) {
    if (error.message.includes('404')) {
      console.warn('⚠️ Persistence endpoint not found (404)');
      console.log('💡 Updates will be frontend-only');
    } else if (error.message.includes('500')) {
      console.error('❌ Server error:', error.message);
    } else {
      console.error('❌ Network error:', error.message);
    }
    return false;
  }
};

/**
 * Test if the Roster refresh button works
 */
window.testRefreshButton = async function() {
  console.log('🔄 Testing Refresh Button...');
  
  // Check if we're on the Roster page
  if (!window.location.pathname.includes('roster')) {
    console.error('❌ Please navigate to the Roster page first');
    return false;
  }

  // Find the refresh button
  const refreshButton = Array.from(document.querySelectorAll('button')).find(btn => 
    btn.textContent.includes('Refresh')
  );

  if (!refreshButton) {
    console.error('❌ Refresh button not found');
    return false;
  }

  if (refreshButton.disabled) {
    console.warn('⚠️ Refresh button is disabled');
    return false;
  }

  console.log('✅ Found refresh button, clicking...');
  refreshButton.click();

  // Wait a bit and check for network activity
  console.log('💡 Check the Network tab for API calls to:');
  console.log('- /api/outcomes/*/persist-role-updates');
  console.log('- Any 200 responses mean persistence is working');
  
  return true;
};

console.log('🔧 Simple persistence test loaded');
console.log('Run: testPersistence() or testRefreshButton()');